<template>
  <div
    class="w-full text-white p-5 md:p-base flex flex-col flex-wrap justify-around"
    :class="mobilePreview ? 'flex-no-wrap' : 'flex-wrap'"
    :style="{
      background: `${brandColour} !important`,
      color: `${contrastColor} !important`
    }"
  >
    <div
      v-if="preferLogoOverIcon && logoPath"
      class="w-full flex justify-center my-8">
      <div
        class="w-full flex items-center md:max-w-4xl justify-center">
        <img
          class="w-auto"
          :class="mobilePreview ? 'logo-mobile-preview' : 'logo-responsive'"
          :src="logoPath"
          alt=""/>
      </div>
    </div>

    <div
      v-else-if="!preferLogoOverIcon"
      class="flex items-center w-full justify-center my-8">
      <div class="w-full flex items-center justify-center md:max-w-4xl">
        <vs-avatar v-if="iconPath" :src="iconPath"/>
        <span
          class="text-inherit font-semibold"
          :class="[
            mobilePreview ? '' : '',
            desktopPreview ? '' : '',
            !mobilePreview && !desktopPreview ? 'md:text-3xl' : '',
            iconPath ? 'ml-3' : ''
          ]"
        >
          {{ brandName }}
        </span>
      </div>
    </div>

    <div
      v-else
      class="flex items-center w-full justify-center">
      <div class="w-full flex items-center justify-center md:max-w-4xl">
        <span
          class="text-inherit font-semibold text-center"
          :class="[
            mobilePreview ? '' : '',
            desktopPreview ? '' : '',
            !mobilePreview && !desktopPreview ? 'md:text-3xl' : ''
          ]"
        >
          {{ brandName }}
        </span>
      </div>
    </div>

    <!-- Slot for custom content like titles -->
    <slot></slot>

  </div>
</template>

<script>
import { getContrastColor } from '@/utils/colorUtils';

export default {
  name: 'HostedPageBanner',
  props: {
    brandName: {
      type: String,
      required: true,
    },
    brandColour: {
      type: String,
      required: true,
    },
    iconPath: {
      type: String,
      default: '',
    },
    logoPath: {
      type: String,
      default: '',
    },
    preferLogoOverIcon: {
      type: Boolean,
      default: false,
    },
    mobilePreview: {
      type: Boolean,
      default: false,
    },
    desktopPreview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    contrastColor() {
      return getContrastColor(this.brandColour);
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-responsive {
  max-height: 55px !important;
  max-width: 120px !important;

  @media (min-width: 768px) {
    max-height: 80px !important;
    max-width: 200px !important;
  }
}

.logo-mobile-preview {
  max-height: 55px !important;
  max-width: 120px !important;
}

.con-vs-avatar {
  @apply bg-white;
}
</style>
